import styled from '@emotion/styled'
import { Card, Box, IconButton } from '@mui/material'

export const InterventionCard = styled(Card)`
  margin-bottom: 16px;
  padding: 16px;
  cursor: pointer;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`

export const StatusIcon = styled(Box)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`

export const UserInfo = styled(Box)`
  display: flex;
  flex-direction: column;
`

export const ActionButtons = styled(Box)`
  display: flex;
  gap: 8px;
  margin-top: 16px;
`

export const TabPanel = styled(Box)`
  padding: 24px 0;
`

export const MessagePreview = styled(Box)`
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
  margin: 8px 0;
  max-height: 150px;
  overflow-y: auto;
`

export const InterventionHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
`

export const InterventionContent = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const FeedbackSection = styled(Box)`
  padding: 16px;
  background-color: #fafafa;
  border-radius: 8px;
  margin-top: 16px;
`

export const ActionButton = styled(IconButton)`
  &:hover {
    background-color: #f0f0f0;
  }
`
